export const subtitles = {
    "1": {
        "startTime": 10.33,
        "endTime": 14.87,
        "transcript": "Unaqililuni, una-ll' unaqilingluni.",
        "translation": "This hand has become dextrous, and this is getting dextrous."
    },
    "2": {
        "startTime": 14.915,
        "endTime": 17.425,
        "transcript": "Oh, quyanaqvaa-lli. (Ii-i.)",
        "translation": "Oh, thank goodness. (Yes.)"
    },
    "3": {
        "startTime": 17.475,
        "endTime": 25.265,
        "transcript": "Tau͡gaam maa-i tegulautellra piniacugtuq, imucetun ciunganicetun pivkenani.",
        "translation": "But now, they are too weak to grab things, unlike before."
    },
    "4": {
        "startTime": 27.515,
        "endTime": 32.605,
        "transcript": "Taumek uqamailnguarnek canek tegucuitelalrianga.",
        "translation": "That's why I don't grab anything heavy."
    },
    "5": {
        "startTime": 33.275,
        "endTime": 37.925,
        "transcript": "Au͡g'um tau͡gaam tutgaura'urluma aulukuraurlularaanga.",
        "translation": "But my dear grandchild takes care of me."
    },
    "6": {
        "startTime": 37.985,
        "endTime": 39.325,
        "transcript": "Camiungua?",
        "translation": "Where's he from?"
    },
    "7": {
        "startTime": 40.28,
        "endTime": 44.02,
        "transcript": "Tutga'rqa makumiungulria-wa.",
        "translation": "My grandchild is from here."
    },
    "8": {
        "startTime": 44.235,
        "endTime": 49.985,
        "transcript": "Aanangqertuq. Aanii kanani unani enengqertuq.",
        "translation": "He has a mother. His mother has a house down there."
    },
    "9": {
        "startTime": 52.335,
        "endTime": 54.145,
        "transcript": "Tutgarqaqa.",
        "translation": "He's my grandchild."
    },
    "10": {
        "startTime": 64.395,
        "endTime": 70.855,
        "transcript": "Tua-i tang allragni uumek assilingrilngua nal'aqertellrani.",
        "translation": "Last year, I was not comfortable with this when it was paralyzed."
    },
    "11": {
        "startTime": 71.5,
        "endTime": 73.75,
        "transcript": "Tua-i pinianani.",
        "translation": "It was weak."
    },
    "12": {
        "startTime": 74.07,
        "endTime": 82.11,
        "transcript": "Maa-i tua-i cali uqamailngurnek tegutellerkaa murilkurluku pila'arqa.",
        "translation": "Even now, I am still careful about grabbing anything heavy with it."
    },
    "13": {
        "startTime": 83.865,
        "endTime": 86.635,
        "transcript": "Ayautenrilkaten-kiq cayarcit?",
        "translation": "I wonder what would've happened to you if he didn't take you to the hospital?"
    },
    "14": {
        "startTime": 86.665,
        "endTime": 89.055,
        "transcript": "Naamell'. Tua-i...",
        "translation": "I don't know. Well..."
    },
    "15": {
        "startTime": 89.375,
        "endTime": 91.765,
        "transcript": "....now, get a good shot, and...",
        "translation": "...now, get a good shot, and..."
    },
    "16": {
        "startTime": 93.285,
        "endTime": 95.305,
        "transcript": "Kituusit Yugtun?",
        "translation": "What's your Yup'ik name?"
    },
    "17": {
        "startTime": 95.78,
        "endTime": 97.31,
        "transcript": "Cuukvaugua.",
        "translation": "I'm Cuukvak."
    },
    "18": {
        "startTime": 97.62,
        "endTime": 102.87,
        "transcript": "Cuukvagmek piuratuanga im' aanallma, aanallma.",
        "translation": "My late mother would always call me Cuukvak."
    },
    "19": {
        "startTime": 109.01,
        "endTime": 119.46,
        "transcript": "Man'a maa-i qanemcikaput maniciqaput, naunraat-wa pilallratnek, imumirpak-llu iqvauralallratnek",
        "translation": "We will show these story about cloudberries and how they pick berries in recent times"
    },
    "20": {
        "startTime": 119.935,
        "endTime": 123.07,
        "transcript": "Yuut iqvalallrat akutarkangengnaqluteng.",
        "translation": "How people pick berries for Eskimo ice cream."
    },
    "21": {
        "startTime": 123.07,
        "endTime": 124.32,
        "transcript": "Tua-i-wa.",
        "translation": " There you have it."
    },
    "22": {
        "startTime": 124.42,
        "endTime": 126.71,
        "transcript": "Miktellerpeni-qaa pilallruuten?",
        "translation": "Did you also do that when you were small?"
    },
    "23": {
        "startTime": 127.02,
        "endTime": 137.04,
        "transcript": "Wiinga-llu aanaka unguvaluni, alqaqa-ll' unguvaluni, kat'um Mary Evon-am maurlua",
        "translation": "Me, my mother was alive, and my sister was alive, Mary Evon's grandmother down there"
    },
    "24": {
        "startTime": 137.375,
        "endTime": 140.425,
        "transcript": "Kana-i kankurluut ilakanka.",
        "translation": "I'm related to those dear ones down there."
    },
    "25": {
        "startTime": 140.735,
        "endTime": 144.235,
        "transcript": "Maurluqaat. Maurluat.",
        "translation": "She's their grandmother. Their grandmother."
    },
    "26": {
        "startTime": 144.47,
        "endTime": 159.742,
        "transcript": "Aanangqertut alqama, alqama alqaqlaliaratnek aanangertut ukut.",
        "translation": "Their mother is my older sister's adopted older sister."
    },
    "27": {
        "startTime": 160.859,
        "endTime": 162.282,
        "transcript": "Iqvalallruuci?",
        "translation": "Would you pick berries?"
    },
    "28": {
        "startTime": 162.655,
        "endTime": 164.786,
        "transcript": "Ii-i, iqvaraqluta.",
        "translation": "Yes, we would pick berries."
    },
    "29": {
        "startTime": 164.896,
        "endTime": 170.573,
        "transcript": "Aren tua-i wiinga maligucuktalallruyaaqua nasaurlucuaraulua.",
        "translation": "Oh my, I would wish to go with them as a little girl."
    },
    "30": {
        "startTime": 172.279,
        "endTime": 178.818,
        "transcript": "Aanama tang qessaknauraanga qiangyugnilua uqilaitnilua-llu.",
        "translation": "My mother would refuse me saying that I would start crying and that I was too slow."
    },
    "31": {
        "startTime": 179.128,
        "endTime": 184.428,
        "transcript": "Tua-i iliini unegtaqlua.",
        "translation": "I would sometimes stay behind."
    },
    "32": {
        "startTime": 184.911,
        "endTime": 189.572,
        "transcript": "Iliini-am tua-i aguagtaqama malikelaraanga.",
        "translation": "When I was insistent sometimes, she would take me with her."
    },
    "33": {
        "startTime": 190.429,
        "endTime": 194.09,
        "transcript": "Qaillun iqvaryalallruceci akaar?",
        "translation": "How would you travel to pick berries long ago?"
    },
    "34": {
        "startTime": 194.219,
        "endTime": 198.866,
        "transcript": "Akaar piyuagurluta ayagnaurtukut.",
        "translation": "Long ago, we would travel only by walking."
    },
    "35": {
        "startTime": 199.41,
        "endTime": 206.218,
        "transcript": "Unaggun un'a Mamterillrem ketii en'arpaullruuq ak'akik'.",
        "translation": "Down toward the water from Bethel, there was a large expansive sandbar."
    },
    "36": {
        "startTime": 206.223,
        "endTime": 213.754,
        "transcript": "Kuiggaq-wa man' Kepenkuyagaq. Nutaan-wa kellia una Kusquqvak, Kusquqvauluni.",
        "translation": "And the creek here was Kepenkuyagaq. Then toward the water from there was the Kuskokwim."
    },
    "37": {
        "startTime": 214.678,
        "endTime": 221.525,
        "transcript": "En'arpaungan unaggun Ekviim aciakun anelrarnaurtukut.",
        "translation": "Because it was a big sandbar, we would go downriver under Ekvik."
    },
    "38": {
        "startTime": 221.537,
        "endTime": 233.324,
        "transcript": "Tuaggun-llu hospital-aam ketiikun mayuryarartangqerran waten qanikciurumaluni",
        "translation": "And through there, since there was a path up toward the water from the hospital that was shoveled"
    },
    "39": {
        "startTime": 233.747,
        "endTime": 236.109,
        "transcript": "Tamaaggun mayurnaurtukut.",
        "translation": "We would go up through there."
    },
    "40": {
        "startTime": 236.119,
        "endTime": 247.585,
        "transcript": "Tua-i utercameng-llu tamaaggun cali unaggun Ekviim aciakun itrarnaurtut qaill' pivkenateng piyuagurluteng.",
        "translation": "And then when they went home, they would go upriver under Ekvik again no other way but walking."
    },
    "41": {
        "startTime": 247.632,
        "endTime": 253.35,
        "transcript": "Qaillun akuteqarraarqameng pilallruat? Qaillun canek akuyucilallruat?",
        "translation": "How did they make their first Eskimo ice cream? What did they use to make Eskimo ice cream?"
    },
    "42": {
        "startTime": 253.854,
        "endTime": 260.204,
        "transcript": "Akutaqluteng, canek, tunurrarnek.",
        "translation": "They would make Eskimo ice cream out of, you know, a little tallow."
    },
    "43": {
        "startTime": 260.921,
        "endTime": 269.621,
        "transcript": "Tunurrarmek-llu egciriluteng tangvallrenka imkut yullret.",
        "translation": "And people I used to see back then would render tallow."
    },
    "44": {
        "startTime": 270.408,
        "endTime": 278.731,
        "transcript": "Cunawa-qaa yuram-llu nalliini aanaka akutesteńgulallinilria.",
        "translation": "It turned out that my mother would be the one to make Eskimo ice cream during dance festivals."
    },
    "45": {
        "startTime": 279.416,
        "endTime": 289.67,
        "transcript": "Aquinginanemni tuavet enerrarmun camun, neqiviggarmun iternaurtua aanaka una akutellria.",
        "translation": "As I was playing, I would go into that little house, a little food cache, to find my mother making Eskimo ice cream."
    },
    "46": {
        "startTime": 289.98,
        "endTime": 297.664,
        "transcript": "Cat tua-i-w' qasgimun pikaitnek yuut ikayualuki.",
        "translation": "She would help by bringing something for the people in the community house."
    },
    "47": {
        "startTime": 300.328,
        "endTime": 308.428,
        "transcript": "Yaa, akaar-qaa tamaani angutet qasgimi piuralallratni uptelallruaci neqkait?",
        "translation": "Okay, when the men would stay in the community house long ago, would you prepare their food?"
    },
    "48": {
        "startTime": 309.679,
        "endTime": 323.121,
        "transcript": "Wiinga qasgimun nasaurlurluulua kelgisqaqatnga-llu alarqaqlua kelgitullruunga.",
        "translation": "When they asked me to invite people from the community house as a little girl, I would constantly invite the wrong people."
    },
    "49": {
        "startTime": 323.53,
        "endTime": 330.329,
        "transcript": "Agayuur, Agayuur nulirran kelgesqaqaku qasgimi",
        "translation": "When Agayuur's wife asked me to invite him from the community house"
    },
    "50": {
        "startTime": 330.572,
        "endTime": 338.801,
        "transcript": "Qavalriit amllelaata qasgimi cauciinaki wii picimtun piaqluki.",
        "translation": "Because there were a lot of people sleeping in the community house, I would wake a random one."
    },
    "51": {
        "startTime": 339.428,
        "endTime": 342.597,
        "transcript": "Maknaurtut una allauluni.",
        "translation": "They would wake up and this would be a different person."
    },
    "52": {
        "startTime": 343.079,
        "endTime": 347.865,
        "transcript": "Nutaan piaqluku wii tauna Oscar kelegniluku.",
        "translation": "I would then tell him that Oscar was invited."
    },
    "53": {
        "startTime": 348.46,
        "endTime": 353.406,
        "transcript": "Nutaan tua-i paqnauraat. Unilluki an'aqlua.",
        "translation": "They would then go to him. I would go out and leave them."
    },
    "54": {
        "startTime": 354.548,
        "endTime": 362.148,
        "transcript": "Qaillun uptelallruit, aren, iqvarraarluteng atsatateng qaillun qemagtelallruitki?",
        "translation": "How did they prepare, I mean, how did they store the berries that they picked?"
    },
    "55": {
        "startTime": 362.197,
        "endTime": 369.405,
        "transcript": "Qemagtelallruit assigtarluki, puckanun-llu imirtuulluki.",
        "translation": "They would store them in containers, then put them into barrels."
    },
    "56": {
        "startTime": 369.743,
        "endTime": 375.243,
        "transcript": "Upluki iqvateng puckurluki",
        "translation": "They prepared the berries they picked for storage in barrels"
    },
    "57": {
        "startTime": 376.673,
        "endTime": 381.167,
        "transcript": "Camun pellernarqellriamun pivkenaki.",
        "translation": "So that they wouldn't be affected by anything repulsive."
    },
    "58": {
        "startTime": 382.059,
        "endTime": 389.797,
        "transcript": "Tua-i tau͡gken uksurpak yuut imkut akuqurnaurtut, akutaqluteng.",
        "translation": "Yet all winter, the people back then would always make Eskimo ice cream."
    },
    "59": {
        "startTime": 389.918,
        "endTime": 392.549,
        "transcript": "Akutarturcetnauraitkut.",
        "translation": "They would feed us Eskimo ice cream."
    },
    "60": {
        "startTime": 393.689,
        "endTime": 396.496,
        "transcript": "Ayuqenrilngurteggun-qaa pililallruit?",
        "translation": "Would they make them with different things?"
    },
    "61": {
        "startTime": 397.754,
        "endTime": 399.569,
        "transcript": "Ii-i. (Allakauluki?)",
        "translation": "Yes. (Separately?)"
    },
    "62": {
        "startTime": 400.338,
        "endTime": 402.762,
        "transcript": "Ilait-qaa allakauluki pililarait?",
        "translation": "Would they make some of them differently?"
    },
    "63": {
        "startTime": 402.769,
        "endTime": 405.623,
        "transcript": "Naam. Pit-wa...",
        "translation": "I don't know. Well..."
    },
    "64": {
        "startTime": 406.743,
        "endTime": 410.599,
        "transcript": "Kavirlit tau͡gaam allakarrauluki",
        "translation": "The cranberries would be a little different"
    },
    "65": {
        "startTime": 411.655,
        "endTime": 423.288,
        "transcript": "Tangvallemtun wiinga Akulmi uingellemni ayagayaurcama kavirlitaqlua, kavirlinek iqvaraqlua.",
        "translation": "As I have seen, when I took a husband and started traveling in the Akula region, I would pick cranberries."
    },
    "66": {
        "startTime": 423.381,
        "endTime": 434.507,
        "transcript": "Tangvallemtun meliqerluki pinek-llu, luqruuyiit-llu meluitnek.",
        "translation": "As I have seen, I would put it fish roe, you know, even pike roe."
    },
    "67": {
        "startTime": 434.825,
        "endTime": 442.158,
        "transcript": "Meliqerluki qantakun passiluki, passinqegcaarluki meluit.",
        "translation": "I would put in fish roe and crush them in a bowl, completely crush the roe."
    },
    "68": {
        "startTime": 443.018,
        "endTime": 452.04,
        "transcript": "Tua-i-ll' kavirlinek cali pinarian piluku",
        "translation": "And then when it was time, I would add cranberries"
    },
    "69": {
        "startTime": 452.061,
        "endTime": 455.611,
        "transcript": "Nutaan kavirlit imkut nutaan passiluki.",
        "translation": "Then I would crush the cranberries."
    },
    "70": {
        "startTime": 456.021,
        "endTime": 463.454,
        "transcript": "Nutaan qerralluku akulluku imna ellacuar uqiqeraqluku.",
        "translation": "Then I would whip it to have it increase in volume occasionally adding a little seal oil."
    },
    "71": {
        "startTime": 464.209,
        "endTime": 472.22,
        "transcript": "Qerrarnaurtuq imna qantaq, qantapiarraq imangnaurtuq akutarugarmek.",
        "translation": "It would increase and fill the old wooden bowl with a lot of Eskimo ice cream."
    },
    "72": {
        "startTime": 472.608,
        "endTime": 473.741,
        "transcript": "Apqiit-qaa...",
        "translation": "Would they say..."
    },
    "73": {
        "startTime": 474.805,
        "endTime": 478.639,
        "transcript": "Apqait-gguq qerpertat tamaa-i.",
        "translation": "They called those qerpertat."
    },
    "74": {
        "startTime": 479.164,
        "endTime": 481.775,
        "transcript": "Maa-i-rpak-qaa cali pililarngatut?",
        "translation": "Do they still seem to make it today?"
    },
    "75": {
        "startTime": 481.966,
        "endTime": 485.466,
        "transcript": "Ii-i, maa-i cali pililartut.",
        "translation": "Yes, they still make some today."
    },
    "76": {
        "startTime": 486.704,
        "endTime": 489.244,
        "transcript": "Pililartut-wa nallunrilameng.",
        "translation": "They make it because they know how to."
    },
    "77": {
        "startTime": 489.826,
        "endTime": 493.67,
        "transcript": "Elpet-qaa maa-i-rpak atsalugpiarutenglartuten?",
        "translation": "Do you get cloudberries now?"
    },
    "78": {
        "startTime": 493.746,
        "endTime": 503.301,
        "transcript": "Iqvayuirutengrraanemnek waniwa iqvaqsairutua, atsanun-llu ayagnanrirlua waniwa.",
        "translation": "Ever since I've stopped picked berries, I haven't gone, and I've stopped going to berry picking grounds now."
    },
    "79": {
        "startTime": 506.802,
        "endTime": 523.068,
        "transcript": "Tau͡gaam tutgarama iqvallermeggnek tekicameng au͡g'ukun kavirlinek payugtellranga tamakuliqerluki tangvallemtun.",
        "translation": "But when my grandchild and the others arrived and brought me cranberries they picked in that container, I made that as I've seen it."
    },
    "80": {
        "startTime": 524.039,
        "endTime": 530.257,
        "transcript": "Tangvallemtun qerpercaaqlua. Tua-i nalluvkenaku.",
        "translation": "I made qerpertaq as I've seen it. I knew how."
    },
    "81": {
        "startTime": 530.423,
        "endTime": 532.737,
        "transcript": "Allanek-qaa tamakut atengqertut?",
        "translation": "Do those have different names?"
    },
    "82": {
        "startTime": 532.766,
        "endTime": 535.909,
        "transcript": "Wall' waniw' atrit ayuqenrilnguut akutaat:",
        "translation": "Or, here are the different names for Eskimo ice cream:"
    },
    "83": {
        "startTime": 536.12,
        "endTime": 537.291,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "84": {
        "startTime": 537.359,
        "endTime": 538.373,
        "transcript": "Passiaq",
        "translation": "Crushed fish eggs and berries"
    },
    "85": {
        "startTime": 539.17,
        "endTime": 540.027,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "86": {
        "startTime": 540.524,
        "endTime": 541.903,
        "transcript": "Tunguggluk-mi cauga?",
        "translation": "But what's tenguggluk?"
    },
    "87": {
        "startTime": 541.912,
        "endTime": 549.162,
        "transcript": "Tenguggluk-wa neqet aqsaqu͡rit, neqpiat aqsaqu͡rit tenguit.",
        "translation": "Tenguggluk is made from fish guts, salmon liver."
    },
    "88": {
        "startTime": 549.792,
        "endTime": 554.75,
        "transcript": "Makut-llu natait cali kepuqcaarturluki",
        "translation": "And then cutting some of their parts"
    },
    "89": {
        "startTime": 556.76,
        "endTime": 561.539,
        "transcript": "Tenguggluk imna akuqaarluku",
        "translation": "After whipping the livers for tenguggluk"
    },
    "90": {
        "startTime": 561.967,
        "endTime": 562.717,
        "transcript": "Qaillun?",
        "translation": "How does it go?"
    },
    "91": {
        "startTime": 563.379,
        "endTime": 574.542,
        "transcript": "Tua-i-wa qell'uku, qell'uku, qell'uki imkut neqet tenguyagait akulluki-llu.",
        "translation": "They squeeze the small fish livers then whip them."
    },
    "92": {
        "startTime": 575.447,
        "endTime": 576.141,
        "transcript": "Tua-i-qaa?",
        "translation": "Do you get it?"
    },
    "93": {
        "startTime": 576.941,
        "endTime": 585.515,
        "transcript": "(Yaa.) Qantaq imirnauraat qivirluku-llu atsanek akulluku-llu.",
        "translation": "(Yes.) They would fill the bowl, add berries, and mix it."
    },
    "94": {
        "startTime": 585.952,
        "endTime": 589.632,
        "transcript": "Uqirluku tau͡gaam, uqiraqluku.",
        "translation": "But they would add seal oil."
    },
    "95": {
        "startTime": 589.702,
        "endTime": 591.008,
        "transcript": "Yaa. (Yaa.)",
        "translation": "I see. (Okay.)"
    },
    "96": {
        "startTime": 591.016,
        "endTime": 593.216,
        "transcript": "Allamek-qaa ilakangqertuten?",
        "translation": "Do you have anything else to add?"
    },
    "97": {
        "startTime": 593.56,
        "endTime": 595.214,
        "transcript": "Naamell'.",
        "translation": "I'm not sure."
    },
    "98": {
        "startTime": 595.84,
        "endTime": 599.954,
        "transcript": "Allakamek-wa ilakaicugnarqellrianga. (Yaa, quyanaqvaa.)",
        "translation": "I don't think I have anything else to add. (Okay, thank you very much.)"
    },
    "99": {
        "startTime": 599.974,
        "endTime": 608.108,
        "transcript": "Tangvallemtun tua-i wiinga-ll' ayagyaurcamegnuk aipangllemni",
        "translation": "As I have seen, when I got married and we started traveling"
    },
    "100": {
        "startTime": 608.873,
        "endTime": 615.486,
        "transcript": "Kavirlinek tua-i iqvangnaqa'artelalrianga irnialleraanka unguvallratni.",
        "translation": "I would try to pick cranberries when my children were alive."
    },
    "101": {
        "startTime": 616.94,
        "endTime": 620.767,
        "transcript": "Peng'garrluki tuaten kavirlinek iqvarlua.",
        "translation": "I would also be worried about them and pick cranberries."
    },
    "102": {
        "startTime": 621.78,
        "endTime": 627.013,
        "transcript": "Tua-i tau͡gken passiluki, passiluki akulluki.",
        "translation": "However, I would crush them to make Eskimo ice cream."
    },
    "103": {
        "startTime": 629.422,
        "endTime": 637.369,
        "transcript": "Mikelngullraat tua-i imkut quyurramta tua-i uitatullruukut Lloyd-ankuk-llu, Old Man Lloyd-ankuk.",
        "translation": "We and the children loved together along with Lloyd, Old Man Lloyd and his wife."
    },
    "104": {
        "startTime": 640.393,
        "endTime": 643.413,
        "transcript": "Lloyd Nick-aq-llu nulirra-llu.",
        "translation": "Lloyd Nick and his wife."
    },
    "105": {
        "startTime": 644.443,
        "endTime": 650.529,
        "transcript": "Imna-llu Helen-aaq-llu quyurramta pania-llu uitallruukut.",
        "translation": "We also lived together with Helen and her daughter."
    },
    "106": {
        "startTime": 651.18,
        "endTime": 654.965,
        "transcript": "Tua-i-ll' akucama nani wani",
        "translation": "And then when I was making Eskimo ice cream somewhere here"
    },
    "107": {
        "startTime": 656.141,
        "endTime": 664.887,
        "transcript": "Mikelngullraat imkut tailuteng wavet aqumluteng tangvagnauraatnga piqa'aqluteng.",
        "translation": "Those children would come here to sit and watch, occassionally tasting it."
    },
    "108": {
        "startTime": 665.16,
        "endTime": 672.253,
        "transcript": "Qiviamku-llu nerengluteng. Ilangciksaunaki-ll' wii akullua, qanruteksaunaki.",
        "translation": "And when I added berries to it, they started eating. I ignore them and made the Eskimo ice cream without saying anything to them."
    },
    "109": {
        "startTime": 672.645,
        "endTime": 680.085,
        "transcript": "Piaqluki, \"Akutalngukuvci taqkici tua-i. Akutaq un' taqniarartuq.\"",
        "translation": "I would say to them, \"Stop when you've had enough Eskimo ice cream. This is almost done.\""
    },
    "110": {
        "startTime": 682.114,
        "endTime": 686.054,
        "transcript": "Quyana. (Yaa.) Quyana cakneq. (Yaa.)",
        "translation": "Thank you. (Yes.) Thank you very much. (Yes.)"
    },
    "111": {
        "startTime": 746.165,
        "endTime": 751.519,
        "transcript": "Ellirraarluku kanavet taukunun tuiggluku an'aqua.",
        "translation": "After I set it down there, I would look back and go out."
    },
    "112": {
        "startTime": 753.88,
        "endTime": 758.868,
        "transcript": "Uicungama-am piyaaqelaraitnga, \"Yuraqtarlutek ata.\"",
        "translation": "My male cousins would say to me, \"Dance, dear ones.\""
    },
    "113": {
        "startTime": 760.554,
        "endTime": 766.114,
        "transcript": "Aullu yag'arcugnaunii-ll' anqertaqellrianga umiga'rrlua.",
        "translation": "Oh my, I wouldn't raise my hands to dance but go out and disappear."
    },
    "114": {
        "startTime": 766.366,
        "endTime": 774.02,
        "transcript": "Ingulak camek meaning-aangqerta? Camek taikaniutengqerta ingulagyaraq? Cauga?",
        "translation": "What does ingulak mean? What explanation does the practice of ingulak have? What is it?"
    },
    "115": {
        "startTime": 778.364,
        "endTime": 784.111,
        "transcript": "Ingularturatuut waten uksuaryartumi.",
        "translation": "They hold the Ingulaq Festival towards fall like this."
    },
    "116": {
        "startTime": 786.081,
        "endTime": 790.171,
        "transcript": "Camek-wa iqungqerta? Nallukeka tayima wiinga.",
        "translation": "I'm not sure what it means. I myself don't know."
    },
    "117": {
        "startTime": 790.182,
        "endTime": 795.016,
        "transcript": "(Naunrat-qaa kinguatni pilartut?) Ii-i, naunraat kinguatni.",
        "translation": "(Would they do it after cloudberry season?) Yes, after cloudberry season."
    },
    "118": {
        "startTime": 795.533,
        "endTime": 800.72,
        "transcript": "Tua-i akutat tau͡gaam ikgetevkenateng qasgimi.",
        "translation": "But there was a lot of Eskimo ice cream in the community house."
    },
    "119": {
        "startTime": 801.715,
        "endTime": 804.502,
        "transcript": "Qasgiqu'urluki, qasgilluki.",
        "translation": "They would always take them to the community house."
    },
    "120": {
        "startTime": 804.535,
        "endTime": 809.608,
        "transcript": "Allanret yugyakange'rmeng piillitaryugnaunateng tua-i.",
        "translation": "Even though there were a multitude of guests, they wouldn't lack anything."
    },
    "121": {
        "startTime": 810.526,
        "endTime": 816.506,
        "transcript": "Tamaaggun-qaa amllermek pilillermegteggun nallunairluteng naunrillruciat?",
        "translation": "Would they know how much berries they picked by making a lot?"
    },
    "122": {
        "startTime": 816.654,
        "endTime": 818.514,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "123": {
        "startTime": 821.206,
        "endTime": 821.999,
        "transcript": "Yaa.",
        "translation": "I see."
    },
    "124": {
        "startTime": 822.688,
        "endTime": 823.282,
        "transcript": "Tua-i-qaa?",
        "translation": "Is that all?"
    },
    "125": {
        "startTime": 823.304,
        "endTime": 825.764,
        "transcript": "Yaa, quyanaqvaa-w' tua-i.",
        "translation": "Yes, thank you very much."
    },
    "126": {
        "startTime": 826.13,
        "endTime": 828.964,
        "transcript": "Qanercetenritarpetegnga amllermek.",
        "translation": "You didn't ask me to speak too much."
    }
};